export default {
  zh: {
    user: '用户',
    registered: '通过您的邀请码注册',
    purchased: '通过您的邀请码注册,并且已经消费。',
    time: '时间',
    description: '描述'
  },
  en: {
    user: 'Your friend ',
    registered: ' use your affiliate code to register.',
    purchased: ' use your affiliate code to register and successfully purchase a package.',
    time: 'Time',
    description: 'Description'
  }
}



// WEBPACK FOOTER //
// ./src/components/commission/friendRecords/lang.js